import script from "./EventoImageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoImageCard.vue?vue&type=script&setup=true&lang=js"

import "./EventoImageCard.vue?vue&type=style&index=0&id=90e2e216&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90e2e216"]])

export default __exports__